import { styled } from 'styled-components';

const StyledPage = styled('div')`
  flex-grow: 1;
  overflow: auto;
  display: flex;
  flex-direction: column;
  position: relative;
`;

export default StyledPage;
